import React from 'react';
import {
  capitalize,
  isEmpty,
} from 'lodash';
import VisualUpload from './VisualUpload';
import './MediaItems.scss';

function MediaItems({
  visualFiles,
  onUpdateVisualFiles,
  resolutions,
  messageStatus,
  resolutionErrors,
}) {
  return (
    <div className="MediaItems">
      {resolutionErrors && (
        <div className="resolution-error">Location details have changed.
          Some of the items you attempted to upload no longer match a selected location resolution
        </div>
      )}
      {resolutions.length > 0 ? resolutions.map((resolution, i) => {
        /* eslint-disable-next-line max-len */
        const visualItem = visualFiles.filter(visualfile => (resolution.size[0] === visualfile.targetScreen.resolution[0]
          && resolution.size[1] === visualfile.targetScreen.resolution[1]
          && resolution.orientation === visualfile.targetScreen.orientation));

        return (
          <div className="media-item" key={i}>
            <div className="media-item-resolution">
              {resolution.name} - {capitalize(resolution.orientation)} - {resolution.size[0]}x{resolution.size[1]}
              {/* <span className="field-dot" /> */}
            </div>
            <div className="media-item-drop">
              <VisualUpload
                file={!isEmpty(visualItem) ? visualItem[0] : {}}
                onUpdateVisualFiles={onUpdateVisualFiles}
                targetScreen={resolution}
                messageStatus={messageStatus}
                fileIndex={i}
              />
            </div>
          </div>
        );
      }) : <div className="empty-media-items">Select locations before adding media items.</div>}
    </div>
  );
}

/* MediaItems.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  approver: PropTypes.object,
  showWaitingStatus: PropTypes.bool,
  showIcon: PropTypes.bool,
  selectable: PropTypes.bool,
  onSelect: PropTypes.func,
};

MediaItems.defaultProps = {
  className: '',
  style: {},
  approver: {},
  showWaitingStatus: false,
  showIcon: false,
  selectable: false,
  onSelect: () => {},
}; */

export default MediaItems;
